// extracted by mini-css-extract-plugin
export default {"title":"FixedDeposits_title__ZT0eo","wrapper":"FixedDeposits_wrapper__ovwpB"};